module.exports = __webpack_public_path__ + "img/Case_Study_Image_3.ee34aab1.jpg";